import { Input, Select, TextArea } from "@aidkitorg/component-library";
import React from "react";
import { useLocalizedStrings } from "../../../Localization";
import { useAggregationOptions } from "../hooks/useAggregationOptions";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type PieChartFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  groupDataField: string,
  setGroupDataField: (val: string) => void,
 
  aggregation: string,
  setAggregation: (val: string) => void,

  dataField: string,
  setDataField: (val: string) => void
}

export const PieChartFormFields: React.FC<PieChartFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  groupDataField, setGroupDataField,
  aggregation, setAggregation,
  dataField, setDataField
}) => {
  const L = useLocalizedStrings()
  const {aggregationOptions, getAggregationOption} = useAggregationOptions()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()

  return <>
    <Input 
      required
      label={L.admin_panel.dashboards.chart_title}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />

    <Select
      portal
      virtualized
      options={fieldOptions}
      label={L.admin_panel.dashboards.group_by}
      description="Select the field to group pie chart segments by"
      labelLocation="above"
      value={getSelectedFieldOption(groupDataField)}
      onChange={(value) => {
        if (value) setGroupDataField(value.value)
      }}
      placeholder="Choose a field..."
      searchable
    />
    
    <Select
      // TODO: add required
      options={aggregationOptions}
      label={L.admin_panel.dashboards.aggregation}
      description={L.admin_panel.dashboards.aggregation_desc}
      labelLocation="above"
      value={getAggregationOption(aggregation)}
      onChange={(value) => setAggregation(value.value)}
      portal
    />
    {aggregation !== 'Count' && (
      <Select
        options={fieldOptions}
        label={L.admin_panel.dashboards.data_field_cap}
        description="Select the field to aggregate for pie chart values"
        labelLocation="above"
        value={getSelectedFieldOption(dataField)}
        onChange={(value) => {
          if (value) setDataField(value.value)
        }}
        placeholder="Choose a field..."
        searchable
        portal
      />
    )}
    
    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}